/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep, round } from 'lodash';

import React, { createContext, useContext, useState, useMemo } from 'react';

export const StateContext = createContext(null);

export default function PlanningActualProvider({ children, ...props }) {
  const initialSetting = {
    planningActual: null,
    modifiedData: null,
    overAllColumnValues: {
      plannedSales: '0',
      actualSales: '0',
      plannedMix: '0',
      actualMix: '0',
      plannedSalesUnit: '0',
      actualSalesUnit: '0',
      plannedASP: '0',
      actualASP: '0',
      plannedOption: '0',
      actualOption: '0',
      plannedSPO: '0',
      actualCOS: '0',
      actualSPO: '0',
      plannedCOS: '0',
      plannedBuyingMargin: '0',
      actualBuyingMargin: '0',
      plannedMarginRate: '0',
      actualMarginRate: '0',
      plannedCashMargin: '0',
      actualCashMargin: '0',
      plannedMarkdown: '0',
      actualMarkdown: '0',
      plannedMarkdownPer: '0',
      actualMarkdownPer: '0',
      isPlannedSales: true,
      isActualSales: true,
    },

    yearsData: null,
    staticFields: [
      {
        _id: '1',
        keyName: 'plannedSales',
        name: 'Planned Sales',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '2',
        keyName: 'actualSales',
        name: 'Actual Sales',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '3',
        keyName: 'plannedMix',
        name: 'Planned Mix (%)',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '4',
        keyName: 'actualMix',
        name: 'Actual Mix (%)',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '5',
        keyName: 'plannedSalesUnit',
        name: 'Planned Sales Units',
        type: 'input',
        display: true,
        Total: 0,
      },
      {
        _id: '6',
        keyName: 'actualSalesUnit',
        name: 'Actual Sales Units',
        type: 'input',
        display: true,
        Total: 0,
      },
      {
        _id: '7',
        keyName: 'plannedASP',
        name: 'Planned Average Sell Price',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '8',
        keyName: 'actualASP',
        name: 'Actual Average Sell Price',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '9',
        keyName: 'plannedOption',
        name: 'Planned Options',
        type: 'input',
        display: true,
        Total: 0,
      },
      {
        _id: '10',
        keyName: 'actualOption',
        name: 'Actual Options',
        type: 'input',
        display: true,
        Total: 0,
      },
      {
        _id: '11',
        keyName: 'plannedSPO',
        name: 'Planned Sales Per Option',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '12',
        keyName: 'actualSPO',
        name: 'Actual Sales Per Option',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '13',
        keyName: 'plannedCOS',
        name: 'Planned Cost of Sale',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '14',
        keyName: 'actualCOS',
        name: 'Actual Cost of Sale',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '15',
        keyName: 'plannedBuyingMargin',
        name: 'Planned Buying Margin (%)',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '16',
        keyName: 'actualBuyingMargin',
        name: 'Actual Buying Margin (%)',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '17',
        keyName: 'plannedMarginRate',
        name: 'Planned Margin Rate (%)',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '18',
        keyName: 'actualMarginRate',
        name: 'Actual Margin Rate (%)',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '19',
        keyName: 'plannedCashMargin',
        name: 'Planned Cash Margin',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '20',
        keyName: 'actualCashMargin',
        name: 'Actual Cash Margin',
        type: 'calc',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '21',
        keyName: 'plannedMarkdown',
        name: 'Planned Markdown',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '22',
        keyName: 'actualMarkdown',
        name: 'Actual Markdown',
        type: 'calc',
        display: true,
        Total: 0,
      },
      {
        _id: '23',
        keyName: 'plannedMarkdownPer',
        name: 'Planned Markdown %',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
      {
        _id: '24',
        keyName: 'actualMarkdownPer',
        name: 'Actual Markdown %',
        type: 'input',
        display: true,
        Total: 0,
        bgColor: 'bg-gray',
      },
    ],
    validateColumns: {},
    hideAllFields: false,
  };

  const [planningActual, setPlanningActual] = useState(initialSetting);

  const getFieldValue = (keyName, yearIndex, yearData, subCatId, catId) => {
    const yearsData = cloneDeep(planningActual.yearsData);
    let fieldVal;
    let subCatData = null;
    if (yearIndex === 0) {
      const catData = yearsData?.mainYear?.category?.find((mainEle) => mainEle.categoryId._id === catId);
      subCatData = catData && getSubCategoryData(catData, subCatId);
    } else {
      const yearCatData = yearsData.compareYear.find((mainEle) => parseInt(mainEle.year, 10) === yearData);
      const catData = yearCatData?.category?.find((mainEle) => mainEle.categoryId._id === catId);
      subCatData = catData && getSubCategoryData(catData, subCatId);
    }
    fieldVal = subCatData ? subCatData[keyName] : 0;

    return isNaN(fieldVal) ? 0 : fieldVal;
  };

  const getVSData = (keyName, yearData, subCatId, catId) => {
    const vsYearData = cloneDeep(planningActual.vsDataContext);
    let catData = vsYearData?.find(
      (mainEle) => mainEle.mainCategory._id === catId && mainEle.subcategoryId._id === subCatId && parseInt(mainEle.year, 10) === yearData,
    );

    catData = catData ? catData[keyName] : 0;
    return round(catData, 2);
  };

  const getVSCategoryTotal = (keyOne, keyTwo, yearData, catId) => {
    const yearsData = cloneDeep(planningActual.yearsData);

    if (yearsData) {
      const catData = yearsData.mainYear.category.filter((mainEle) => mainEle.categoryId._id === catId);
      let totaMain = 0;

      catData?.map((ele) => ({
        itemPrice: ele.subcategory.forEach((item) => {
          totaMain += Number(item[keyOne]);
        }),
      }));

      const currentTotal = totaMain;

      const yearCatData = yearsData?.compareYear?.find((mainEle) => parseInt(mainEle.year, 10) === yearData);
      const catCompateData = yearCatData?.category?.filter((mainEle) => mainEle.categoryId._id === catId);
      let totaOther = 0;

      catCompateData?.map((ele) => ({
        itemPrice: ele.subcategory.forEach((item) => {
          totaOther += parseFloat(item[keyTwo]);
        }),
      }));

      const prevTotal = totaOther;
      let finalTotal = (currentTotal / prevTotal - 1) * 100;
      const finiteValues = !isFinite(finalTotal) ? 0 : finalTotal;
      finalTotal = isNaN(finalTotal) ? 0 : finiteValues;

      return round(finalTotal, 2);
    }
  };

  const getVSOverallTotal = (keyOne, keyTwo, yearData) => {
    const yearsData = cloneDeep(planningActual.yearsData);

    const allMainTotal = yearsData?.mainYear?.overallTotals[keyOne];

    const yearCatData = yearsData?.compareYear?.find((mainEle) => parseInt(mainEle.year, 10) === yearData);
    const allPrevTotal = yearCatData?.overallTotals[keyTwo];

    let finalTotal = (allMainTotal / allPrevTotal - 1) * 100;
    const finiteValues = !isFinite(finalTotal) ? 0 : finalTotal;
    finalTotal = isNaN(finalTotal) ? 0 : finiteValues;
    return round(finalTotal, 2);
  };
  const getTotalOfField = (keyName, yearIndex, yearData, catId) => {
    const yearsData = cloneDeep(planningActual.yearsData);
    let totalField = null;
    if (yearIndex === 0) {
      const catData = yearsData.mainYear.category.filter((mainEle) => mainEle.categoryId._id === catId);
      let totaMain = 0;
      catData?.map((ele) => ({
        itemPrice: ele.subcategory.forEach((item) => {
          totaMain += parseFloat(item[keyName] ? item[keyName] : 0);
        }),
      }));

      totalField = totaMain;
    } else {
      const yearCatData = yearsData.compareYear.find((mainEle) => parseInt(mainEle.year, 10) === yearData);
      const catData = yearCatData?.category?.filter((mainEle) => mainEle.categoryId._id === catId);
      let totaOther = 0;
      catData?.map((ele) => ({
        itemPrice: ele.subcategory.forEach((item) => {
          totaOther += parseFloat(item[keyName] ? item[keyName] : 0);
        }),
      }));
      totalField = totaOther;
    }

    return round(totalField, 2);
  };

  const getOvarAllFieldTotal = (keyName, yearIndex, yearData) => {
    const yearsData = cloneDeep(planningActual.yearsData);
    let totalField = null;
    if (yearIndex === 0) {
      totalField = yearsData?.mainYear?.overallTotals[keyName];
    } else {
      const yearCatData = yearsData?.compareYear?.find((mainEle) => parseInt(mainEle.year, 10) === yearData);
      totalField = yearCatData?.overallTotals?.[keyName];
    }
    return isNaN(totalField) ? 0 : totalField;
  };
  const getSubCategoryData = (catData, subCatId) => {
    return catData.subcategory.find((subCatEle) => subCatEle.subcategoryId._id === subCatId);
  };

  const checkVisible = (keyName) => {
    const staticKey = cloneDeep(planningActual.staticFields);

    const getKeyData = staticKey.find((ele) => ele.keyName === keyName);
    return getKeyData?.display;
  };
  const contextValue = useMemo(
    () => ({
      _id: '1',
      planningActual,
      setPlanningActual,
      getFieldValue,
      getTotalOfField,
      getOvarAllFieldTotal,
      getVSData,
      getVSCategoryTotal,
      getVSOverallTotal,
      checkVisible,
    }),
    [planningActual, setPlanningActual, getFieldValue, getTotalOfField, getOvarAllFieldTotal, getVSData, getVSCategoryTotal, getVSOverallTotal, checkVisible],
  );

  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function usePlanningActualState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the PlanningActualStateProvider');
  }
  return context;
}
